const currencies = [
  { prefix: '€', name: 'EUR', text: 'Euros' },
  { prefix: '₺', name: 'TRY', text: 'Turkish Lira' },
  { prefix: '$', name: 'USD', text: 'Dollars' },
  { prefix: '৳', name: 'BDT', text: 'Bangladeshi Taka' },
  { prefix: 'Bds$', name: 'BBD', text: 'Barbadian Dollars' },
  { prefix: 'R$', name: 'BRL', text: 'Brazillian Read' },
  { prefix: 'Лв', name: 'BGN', text: 'Bulgarian Lev' },
  { prefix: 'CAD', name: 'CAD', text: 'Canadian Dollars' },
  { prefix: '¥', name: 'CNY', text: 'Chinese Yuan' },
  { prefix: '₡', name: 'CRC', text: 'Costa Rican Colon' },
  { prefix: 'kn', name: 'HRK', text: 'Croatian Kuna' },
  { prefix: 'Kr.', name: 'DKK', text: 'Danish Krone' },
  { prefix: '$', name: 'XCD', text: 'The Eastern Caribbean dollar' },
  { prefix: 'E£', name: 'EGP', text: 'Egyptian Pound' },
  { prefix: 'hk$', name: 'HKD', text: 'Hong Kong Dollar' },
  { prefix: 'ikr', name: 'ISK', text: 'Icelandic Krona' },
  { prefix: '¥', name: 'JPY', text: 'Japanese Yen' },
  { prefix: 'RM', name: 'MYR', text: 'Malaysian Ringgit' },
  { prefix: 'rs', name: 'MUR', text: 'Mauritian Rupee' },
  { prefix: 'mex$', name: 'MXN', text: 'Mexican Peso' },
  { prefix: 'nz$', name: 'NZD', text: 'New Zealand Dollar' },
  { prefix: 'kr', name: 'NOK', text: 'Norwegian Krone' },
  { prefix: 'zł', name: 'PLN', text: 'Polish Złoty' },
  { prefix: 'R', name: 'ZAR', text: 'South African Rand' },
  { prefix: 'kr', name: 'SEK', text: 'Swedish Krona' },
  { prefix: 'Fr.', name: 'CHF', text: 'Swiss Franc' },
  { prefix: 'nt$', name: 'TWD', text: 'Taiwan Dollar' },
  { prefix: '฿', name: 'THB', text: 'Thai Baht' },
  { prefix: 'A$', name: 'AUD', text: 'Australian Dollar' },
  { prefix: 'د.إ', name: 'AED', text: 'UAE Dirham' },
]

export const getPrefix = (name) => currencies.find((c) => c.name === name)?.prefix

export const getText = (name) => currencies.find((c) => c.name === name)?.text
